const PaymentStatus = {
  Paid: "paid",
  Pending: "pending",
  Waived: "waived",
};

export default PaymentStatus;
